import React, { useMemo, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Box,
  TextField,
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, Settings as SettingsIcon } from '@mui/icons-material';

interface TableColumn {
  field: string;
  label: string;
  render?: (value: any, row?: any) => React.ReactNode;
}

interface FinanceTableProps {
  data: any[];
  columns: TableColumn[];
  onEdit?: (item: any) => void;
  /** Для ПС с supports_payout_out — настройки TTL выплат OUT */
  onEditOutSettings?: (item: any) => void;
  /** Для IN-ПС (supports_payout_out !== true) — настройки IN */
  onEditInSettings?: (item: any) => void;
  onDelete: (id: string | number) => void;
}

const FinanceTable: React.FC<FinanceTableProps> = ({
  data,
  columns,
  onEdit,
  onEditOutSettings,
  onEditInSettings,
  onDelete,
}) => {
  const [search, setSearch] = useState('');
  const filteredData = useMemo(() => { const needle = search.trim().toLowerCase(); return needle ? data.filter((row) => columns.some((column) => String(row[column.field] ?? '').toLowerCase().includes(needle))) : data; }, [data, columns, search]);
  return (
    <Box><TextField fullWidth label="Поиск по таблице" value={search} onChange={(event) => setSearch(event.target.value)} sx={{ mb: 2 }} /><TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.field}>{column.label}</TableCell>
            ))}
            <TableCell align="right">Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.map((row) => (
            <TableRow key={row.id}>
              {columns.map((column) => (
                <TableCell key={column.field}>
                  {column.render ? column.render(row[column.field], row) : row[column.field]}
                </TableCell>
              ))}
              <TableCell align="right">
                {onEdit && (
                  <Tooltip title="Редактировать">
                    <IconButton onClick={() => onEdit(row)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {onEditOutSettings && row.supports_payout_out === true && (
                  <Tooltip title="Настройки выплат OUT">
                    <IconButton onClick={() => onEditOutSettings(row)}>
                      <SettingsIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {onEditInSettings && row.supports_payout_out !== true && (
                  <Tooltip title="Настройки IN">
                    <IconButton onClick={() => onEditInSettings(row)}>
                      <SettingsIcon />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Удалить">
                  <IconButton onClick={() => onDelete(row)} sx={{ color: '#d32f2f' }}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer></Box>
  );
};

export default FinanceTable;
